module.exports = __webpack_public_path__ + "img/73a6012.png";